var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSocietaBenefit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.7 64.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,38.7c-.5,0-.9-.4-.9-1V10.3c0-2.6,2-4.8,4.4-4.8s4.4,2.1,4.4,4.8v19c0,.5-.4,1-.9,1s-.9-.4-.9-1V10.3c0-1.6-1.2-2.8-2.6-2.8s-2.6,1.3-2.6,2.8v27.4c0,.5-.4,1-.9,1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.9,30.3c-.5,0-.9-.4-.9-1V4.8c0-1.6-1.2-2.8-2.6-2.8s-2.6,1.3-2.6,2.8v24.6c0,.5-.4,1-.9,1s-.9-.4-.9-1V4.8c0-2.6,2-4.8,4.4-4.8s4.4,2.1,4.4,4.8v24.6c0,.5-.4,1-.9,1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.9,32.3c-.5,0-.9-.4-.9-1V8.7c0-1.6-1.2-2.8-2.6-2.8s-2.6,1.3-2.6,2.8v20.7c0,.5-.4,1-.9,1s-.9-.4-.9-1V8.7c0-2.6,2-4.8,4.4-4.8s4.4,2.1,4.4,4.8v22.6c0,.5-.4,1-.9,1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.3,64.2h-2.1c-4.9,0-9.4-2.6-12.2-7.1L.8,37.5c-.8-1.3-1-2.8-.7-4.3.4-1.5,1.3-2.7,2.5-3.4,1.8-1,4-.6,5.5.8l6.4,6.4c.4.4.4,1,0,1.4-.3.4-.9.4-1.3,0l-6.5-6.4c-.9-.9-2.3-1.2-3.5-.5-.8.4-1.4,1.2-1.6,2.2-.2.9,0,1.9.4,2.7l12.1,19.6c2.4,3.9,6.4,6.3,10.7,6.3h2.1c3.7,0,7.1-1.6,9.7-4.4.3-.4.9-.4,1.3,0,.4.4.4,1,0,1.4-2.9,3.2-6.8,5-11,5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.8,43.7c-.5,0-.9-.4-.9-1v-26.7c0-.8-.3-1.5-.8-2-.5-.5-1.1-.8-1.8-.8-1.4,0-2.6,1.3-2.6,2.8v15.2c0,.5-.4,1-.9,1s-.9-.4-.9-1v-15.2c0-2.6,2-4.8,4.4-4.8s2.3.5,3.1,1.4c.8.9,1.3,2.1,1.3,3.4v26.7c0,.5-.4,1-.9,1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.8,64.1c-.2,0-.5,0-.6-.3l-11-12c-1.4-1.5-2.2-3.6-2.2-5.8s.8-4.2,2.2-5.8c1.4-1.5,3.3-2.4,5.3-2.4s3.9.9,5.3,2.4l1,1.1,1-1.1c1.4-1.5,3.3-2.4,5.3-2.4s3.9.9,5.3,2.4c1.4,1.5,2.2,3.6,2.2,5.8s-.8,4.2-2.2,5.8l-11,12c-.2.2-.4.3-.6.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSocietaBenefit);
export default __webpack_public_path__ + "static/media/ico-societa-benefit.2a1c8cd8ba81ce8afa3ddc4ccb083479.svg";
export { ForwardRef as ReactComponent };